skrilla.directive('ntrcSimpleView', function () {
  return {
    templateUrl: 'directives/ntrcSimpleView/ntrcSimpleView.html',
    scope: {
      key: "=",
      financials: "="
    },
    controller: function ($scope, paginationService) {
      $scope.bets = true;
      $scope.aud = true;
      $scope.intl = true;

      $scope.getRegionTotalsExportData = function () {
        // const headers = Object.keys($scope.financials[0].audFinancials.regionTotals)
        //   .map(it => {
        //     return {
        //       title:it,
        //       field: it.replace("AU:", "")
        //     }
        //   });
        // headers.unshift({title:"Date", field: "date"})
        const headers = [
          {field:"date", title: "Date"},
          {field:"AU:SA", title: "SA"},
          {field:"AU:QLD", title: "QLD"},
          {field:"AU:ACT", title: "ACT"},
          {field:"AU:WA", title: "WA"},
          {field:"AU:NSW", title: "NSW"},
          {field:"AU:VIC", title: "VIC"},
          {field:"AU:TAS", title: "TAS"},
          {field:"AU:NT", title: "NT"},
        ]

         return {
           columns: headers,
           data: $scope.financials.map(it => ({...it.audFinancials.regionTotals, date: it.endTime})),
           isSkrillaTable: true
         }
      }

      $scope.getFxCurrencies = function () {
        if ($scope.financials) {
          return Object.keys($scope.financials[0].fxRates);
        } else {
          return [];
        }
      }

      $scope.getCombinedEntryFees = function (financial) {
        return financial.audFinancials.contestEntryFees + financial.audFinancials.betEntryFees;
      }

      $scope.getCombinedPayouts = function (financial) {
        return financial.audFinancials.contestPayOuts + financial.audFinancials.betPayOuts;
      }

      $scope.getCombinedLiabilities = function (financial) {
        return financial.audFinancials.betLiabilities + financial.audFinancials.prizePoolLiabilities;
      }
    }
  };
});
